import React from 'react';
import times from 'lodash/times';
import { useDisclosuresQuery } from '../../../../api/useDisclosuresQuery';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { TextLoading } from '../../../../../../CommonComponents/OPL/Text/Text.loading';
import { DisclosuresWrapper, Heading1, Heading2, StyledMarkdown } from './Disclosures.styles';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const Disclosures = () => {
  const { isLoading, isError, refetch, data } = useDisclosuresQuery();

  if (isLoading) {
    return (
      <DisclosuresWrapper>
        {times(2).map(key1 => (
          <React.Fragment key={key1}>
            <TextLoading width={200} height="h5" mb="16" mt={key1 !== 0 ? '32' : 0} />

            {times(8).map(key2 => (
              <TextLoading key={key2} width="100%" mb="8" />
            ))}
          </React.Fragment>
        ))}
      </DisclosuresWrapper>
    );
  }

  if (isError) {
    return (
      <DisclosuresWrapper>
        <Box p="56">
          <ErrorState onAction={refetch} />
        </Box>
      </DisclosuresWrapper>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <DisclosuresWrapper>
      {data.map((paragraph, index) => (
        <StyledMarkdown
          key={index} // eslint-disable-line react/no-array-index-key
          options={{
            overrides: {
              h1: {
                component: Heading1,
              },
              h2: {
                component: Heading2,
              },
            },
          }}
        >
          {paragraph}
        </StyledMarkdown>
      ))}
    </DisclosuresWrapper>
  );
};

interface Props {
  onClose(): void;
}

export const DisclosuresModal: React.FC<Props> = ({ onClose }) => (
  <Modal isOpen onRequestClose={onClose}>
    <ModalHeader>Custodial Account Agreement</ModalHeader>
    <ModalCloseButton onClick={onClose} />

    <Disclosures />

    <ModalFooter>
      <Button variant="subtleInactive" onClick={onClose}>
        Close
      </Button>
    </ModalFooter>
  </Modal>
);
